import React from 'react';
import { Query } from 'react-apollo';

import Question from '../../shared/question';

import queries from '../../../graphql/queries';

import style from './index.module.scss';

const {
  questionQueries: { QUESTIONS },
} = queries;

function QuestionsForYou() {
  return (
    <section className={`card row ${style.questions}`}>
      <div className={`col-12 ${style['col--heading']}`}>
        <span className={style['heading-icon']}>
          <i className={`far fa-lightbulb ${style.icon}`} />
        </span>{' '}
        <span className={`text-muted ${style['heading-text']}`}>
          Questions For You
        </span>
      </div>
      <div className={`col-12 ${style['col--question-list']}`}>
        <div className={`row`}>
          <Query query={QUESTIONS}>
            {({ loading, error, data }) => {
              if (loading) return <div>Loading...</div>;
              if (error) return <div>Error!</div>;

              const { questions } = data;

              return (
                <>
                  {questions.map(question => (
                    <Question question={question} key={question.id} />
                  ))}
                </>
              );
            }}
          </Query>
        </div>
      </div>
    </section>
  );
}

export default QuestionsForYou;
